import moment from "moment";
import constants from "../../core/constants";

class Controller {
  constructor(Events, PaymentCycleConfigurations) {
    "ngInject";

    this.Events = Events;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.PaymentCycleConfigurations = PaymentCycleConfigurations;

    this.isDisabled = true;
    this.submitInvoiceCycle = this.submitInvoiceCycle.bind(this);
  }

  $onInit() {
    this.PaymentCycleConfigurations.get(this.cityId)
      .$promise.then((response) => {
        this.invoiceCycleConfiguration = response;
      })
      .catch((err) => {
        if (err.status === 404) {
          this.noCycleFound = true;
          this.invoiceCycleConfiguration = {};
        } else {
          this.Events.emit(this.errorNotificationEvent, err.data);
        }
      });
  }

  createInvoiceCycle() {
    function formatDate(date) {
      return moment(date).format(constants.dateFormat);
    }

    const {
      in_progress_days: inProgressDays,
      pending_days: pendingDays,
      start_date: startDate,
    } = this.invoiceCycleConfiguration;
    this.PaymentCycleConfigurations.post({
      in_progress_days: inProgressDays,
      pending_days: pendingDays,
      start_date: formatDate(startDate),
      city: this.cityId,
    })
      .$promise.then((response) => {
        this.invoiceCycleConfiguration = response;
        this.Events.emit(this.successNotificationEvent, {
          message: "City Invoice Configuration is created successfully",
        });
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }

  updateInvoiceCycle() {
    const {
      _id,
      in_progress_days: inProgressDays,
      pending_days: pendingDays,
    } = this.invoiceCycleConfiguration;
    this.PaymentCycleConfigurations.update(_id, {
      in_progress_days: inProgressDays,
      pending_days: pendingDays,
    })
      .$promise.then((response) => {
        this.invoiceCycleConfiguration = response;
        this.Events.emit(this.successNotificationEvent, {
          message: "City Invoice Configuration is updated successfully",
        });
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }

  submitInvoiceCycle() {
    if (this.noCycleFound) {
      this.createInvoiceCycle();
    } else {
      this.updateInvoiceCycle();
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/cityInvoiceConfiguration/cityInvoiceConfiguration.controller.js